import React, { useCallback, useMemo, useState } from 'react';
import './ConfigUsuarios.scss';
import { ToolbarSimple } from '../../components';
import { ScrollView, TabPanel } from 'devextreme-react';
import { useAppSelector } from '../../contexts/hooks';
import Usuarios from './AdminUsuarios/Index';
import Perfiles from './AdminPerfiles/Index';

const Index = () => {
  const Prm_Conf_Usuario = useAppSelector(x => x.userInfo.Permissions?.Prm_Conf_Usuario);
  
  const items = useMemo(() => [
    {
      id: 1,
      title: 'Usuarios',
      visible: Prm_Conf_Usuario,
      scrollByContent: true,
      scrollingEnabled: true,
    },
    {
      id: 2,
      title: 'Perfiles',
      visible: Prm_Conf_Usuario,
    },
  ], [Prm_Conf_Usuario]);

  const [selectedIndex, setSelectedIndex] = useState(0);

  const onSelectionChanged = (args) => {
    if (args.name === 'selectedIndex') {
      setSelectedIndex(args.value);
    }
  };

  const tabComponents = useMemo(() => {
    return {
      1: <Usuarios />,
      2: <Perfiles />,
    };
  }, []);

  const renderItemP = useCallback(
      (props: any) => {
        switch (props.data.id) {
          case 1:
            if (!Prm_Conf_Usuario) return;
            break;
          case 2:
            if (!Prm_Conf_Usuario) return;
            break;
        }
        const component = tabComponents[props.data.id];
        return component;
      },
      [tabComponents, Prm_Conf_Usuario]
    );

  return (
    <ScrollView className='view-wrapper-scroll'>
      <ToolbarSimple title='Usuarios y perfiles'>
      <div className='dx-card details-card'>
        <TabPanel dataSource={items} deferRendering={true} activeStateEnabled={true} swipeEnabled={false} selectedIndex={selectedIndex} onOptionChanged={onSelectionChanged} animationEnabled={false} loop={false} itemComponent={renderItemP} />
      </div>
      </ToolbarSimple>
    </ScrollView>
  );
};

export default Index;